import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface Location {
	id: string;
	name: string;
	businessName: string;
	address: string;
	city: string;
	state: string;
	zipCode: string;
	phone: string;
	email: string;
	status: 'active' | 'inactive';
}

interface LocationsState {
	locations: Location[];
	addLocation: (location: Location) => void;
	updateLocation: (id: string, location: Location) => void;
	deleteLocation: (id: string) => void;
}

const useLocationsStore = create<LocationsState>()(
	devtools(
		set => ({
			locations: [
				{
					id: '1',
					name: 'Downtown Minneapolis',
					businessName: '200Below',
					address: '123 Main Street',
					city: 'Minneapolis',
					state: 'Minnesota',
					zipCode: '55401',
					phone: '(612) 555-0100',
					email: 'downtown@200below.com',
					status: 'active',
				},
				{
					id: '2',
					name: 'Uptown Location',
					businessName: '200Below',
					address: '456 Lake Street',
					city: 'Minneapolis',
					state: 'Minnesota',
					zipCode: '55408',
					phone: '(612) 555-0200',
					email: 'uptown@200below.com',
					status: 'active',
				},
				{
					id: '3',
					name: 'St. Paul Branch',
					businessName: '200Below',
					address: '789 University Ave',
					city: 'St. Paul',
					state: 'Minnesota',
					zipCode: '55104',
					phone: '(651) 555-0300',
					email: 'stpaul@200below.com',
					status: 'inactive',
				},
			],

			addLocation: location =>
				set(state => ({
					locations: [...state.locations, location],
				})),

			updateLocation: (id, updatedLocation) =>
				set(state => ({
					locations: state.locations.map(l => (l.id === id ? updatedLocation : l)),
				})),

			deleteLocation: id =>
				set(state => ({
					locations: state.locations.filter(l => l.id !== id),
				})),
		}),
		{ name: 'locations-store' }
	)
);

export default useLocationsStore;
